"use strict";

exports.__esModule = true;
exports.userLocale = exports.formatPrice = void 0;
const userLocale = // eslint-disable-next-line no-nested-ternary
typeof navigator !== 'undefined' ? navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language : 'en-US';
exports.userLocale = userLocale;

const formatPrice = (currency, value) => Intl.NumberFormat(userLocale, {
  currency,
  minimumFractionDigits: 2,
  style: 'currency'
}).format(value);

exports.formatPrice = formatPrice;